import * as React from "react";
import { Dialog, DialogTitle, Typography, DialogContent, DialogActions, Button, TextField } from "@material-ui/core";

interface FeedbackRequestDialogProps {
  isMobile: boolean;
  isOpen: boolean;
  onCancelFeedbackRequest: () => void;
  onConfirmFeedbackRequest: (customerFeedback: string) => void;
}

interface FeedbackRequestDialogState {
  customerFeedback: string;
}

class FeedbackRequestDialog extends React.Component<FeedbackRequestDialogProps, FeedbackRequestDialogState> {
  constructor(props: FeedbackRequestDialogProps) {
    super(props);

    this.state = {
      customerFeedback: ""
    };
  }

  onFeedbackChanged = (element: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ customerFeedback: element.target.value });
  };

  onConfirmFeedbackRequest = () => {
    this.props.onConfirmFeedbackRequest(this.state.customerFeedback);
  };

  render() {
    const { isMobile, isOpen, onCancelFeedbackRequest } = this.props;
    return (
      <Dialog open={isOpen}>
        <DialogTitle>
          <Typography variant="h6">Visit Feedback Request</Typography>
        </DialogTitle>
        <DialogContent>
          <Typography>Please tell us more about your experience</Typography>
          <TextField
            style={{ marginTop: "1rem", width: "100%" }}
            id="multiline-static"
            label={isMobile ? "Visit description" : "Tell us about your visit"}
            multiline={true}
            variant="outlined"
            rows="3"
            defaultValue=""
            margin="dense"
            onChange={this.onFeedbackChanged}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={onCancelFeedbackRequest}>
            Dismiss
          </Button>
          <Button variant="outlined" color={"primary"} onClick={this.onConfirmFeedbackRequest}>
            Submit my feedback
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default FeedbackRequestDialog;
